import { Injectable } from '@angular/core';
import { IssueTypeWorkflowStore } from './issueTypeWorkflow.store';
import { IIssueTypeWorkflow } from '@common/interfaces/issueTypeWorflow';
import { IssueTypeWorkflowQuery } from './issueTypeWorkflow.query';
import { CrudService } from '../crudService';
import { BaseEntityStoreStrategy } from '../updateStoreStrategies';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';

@Injectable({
  providedIn: 'root'
})
export class IssueTypeWorkflowService extends CrudService<IIssueTypeWorkflow, IssueTypeWorkflowStore, IssueTypeWorkflowQuery> {
  constructor(
    public store: IssueTypeWorkflowStore,
    public query: IssueTypeWorkflowQuery,
    protected updateStrategy: BaseEntityStoreStrategy,
    protected actionService: ActionService) {
    super(
      Topics.ISSUE_TYPE_WORKFLOWS,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

}
